/* @flow */
const confirmValidator = (password: String, confirmation: String) => {
  return password === confirmation;
};

export default confirmValidator;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/enhancers/validators/confirmValidator.js
 **/